module.exports = __webpack_public_path__ + "static/img/24.dae284e5.png";